import { render, staticRenderFns } from "./OmzetExport.vue?vue&type=template&id=2f3a46bf&"
import script from "./OmzetExport.vue?vue&type=script&lang=js&"
export * from "./OmzetExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports